<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold noprint">Reports</h1>  
    
    <div id="manpower">
      <h2 class="mb-2 text-2xl font-bold">{{ this.getJobsiteName() }}: Manpower, Weather by Day</h2>  
      <h5 class="italic font-bold">Generated: <span id="generatedat"></span></h5>
      <ReportChart :daylogs="daylogs" />
    </div>
  </div>
</template>
<style>
@media print {
  .onlyprint { display:initial; }
  .noprint, #mainmenu { display:none; }
  * { border:0px solid #FFF !important; }
  #ordercontainer {box-shadow:none !important; }
  .nobreak, .nobreak canvas, .nobreak * { page-break-inside: avoid; }
  svg.dp__icon { display:none; }
  .tabulator-cell svg { display:none; }
  .text-3xl { font-size:1.4rem; }
  * { overflow:hidden !important; }
  canvas { margin-top:40px; display: block; max-width: 100%; height:auto; }
}
</style>
<script>
import {computed, defineComponent, ref } from 'vue';
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import moment from 'moment'
import ReportChart from '@/Shared/ReportChart'

export default {
  mounted() {
  },
  components: {
    Head,
    Link,
    Icon,
    ReportChart,
  },
  layout: Layout,
  props: {
    jobsites: Object,
    purchaseorders: Object,
    orders: Object,
    daylogs: Object,
    auth: Object,
  },
  data() {
    return {
      moment: moment,
    }
  },
  methods: {
    getJobsiteName() {
      var cookiejobsite = parseInt(document.cookie.split('jobsite=')[1].split('; ')[0]);
      var jsname = "";
      this.jobsites.data.forEach(function(v,k) {
        if (v.id == cookiejobsite) {
          jsname = v.sitename;
        }
      });
      return jsname;
    },
    handler() {
      var args = arguments;
      for (var arg of args) {
        if (arg instanceof Function) {
          arg();
        }
      }
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try {
        window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); 
      },1);
      } catch(e) { console.error(e); }
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      this.jobsites.data.forEach((js) => {
        if (jsa[js.id] == 1) {
          jobsitesyes.push(js);
        }
      });
      return jobsitesyes;
    },
  },
}
</script>